export default {"src":"/_next/static/media/event.61135416.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};